import React from 'react';

function Venezuela(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_123963)">
        <mask
          id="mask0_800_123963"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_123963)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V24H36V0H0Z"
            fill="#2E42A5"
          />
          <mask
            id="mask1_800_123963"
               style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="36"
            height="24"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V24H36V0H0Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_800_123963)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V8H36V0H0Z"
              fill="#FECA00"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 16V24H36V16H0Z"
              fill="#E31D1C"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M14.3291 11.8594L15.4346 11.3019L16.675 11.8594L16.2296 10.7264L17.1561 9.89379H15.9769L15.4329 8.82159L14.969 9.89379H13.5858L14.6259 10.7115H13.4594L12.9154 9.63928L12.4515 10.7115H11.0683L12.1273 11.5441L11.9249 12.2704H11.0423L10.4983 11.1982L10.0344 12.2704H8.65117L9.71017 13.103L9.51431 13.8059H9.12791L8.58393 12.7337L8.12002 13.8059H6.73682L7.79582 14.6385L7.48008 15.7715L8.5856 15.214L9.82605 15.7715L9.38057 14.6385L10.3071 13.8059H10.2475L10.5 13.6786L11.7404 14.2361L11.2949 13.103L11.8258 12.6259L11.8116 12.6771L12.9171 12.1196L14.1575 12.6771L13.7121 11.5441L14.6326 10.7168L14.6448 10.7264L14.3291 11.8594Z"
              fill="#F7FCFF"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M21.6259 11.8156L20.5203 11.2581L19.2799 11.8156L19.7254 10.6826L18.7989 9.84996H19.978L20.522 8.77777L20.9859 9.84996H22.3691L21.3291 10.6677H22.501L23.045 9.59546L23.5089 10.6677H24.8921L23.8331 11.5002L24.0356 12.2266H24.9182L25.4621 11.1544L25.9261 12.2266H27.3093L26.2503 13.0592L26.4461 13.762H26.8325L27.3765 12.6898L27.8404 13.762H29.2236L28.1646 14.5946L28.4804 15.7277L27.3748 15.1702L26.1344 15.7277L26.5799 14.5946L25.6534 13.762H25.7129L25.4605 13.6347L24.22 14.1922L24.6655 13.0592L24.1346 12.5821L24.1489 12.6333L23.0434 12.0758L21.8029 12.6333L22.2484 11.5002L21.3253 10.6707L21.3101 10.6826L21.6259 11.8156Z"
              fill="#F7FCFF"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M17.8122 10.5347L16.7066 11.0922L17.0224 9.95917L15.9634 9.12657H17.3466L17.8105 8.05438L18.3545 9.12657H19.5336L18.6071 9.95917L19.0526 11.0922L17.8122 10.5347Z"
              fill="#F7FCFF"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_123963">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Venezuela;
